const NEWEST = Symbol('newest');
const EXPIRE_SOON = Symbol('expireSoon');

const context = new Map([
  [NEWEST, 'sg_latest'], [EXPIRE_SOON, 'sg_expiring'],
]);

export {
  NEWEST,
  EXPIRE_SOON,
  context
};
